<div
  class="areYouSure"
  fxLayout="column"
  FxFlex="50"
  fxLayoutAlign="space-between center"
>
  <h3>آیا از انجام عملیات مطمئن هستید ؟</h3>

  <div
    class="buttons"
    mat-dialog-actions
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <button color="warn" mat-button (click)="onOk()">بله</button>
    <button color="primary" mat-button (click)="onCancel()">خیر</button>
  </div>
</div>
